import { Button, ButtonProps } from "components/Buttons";

type SecondaryButtonProps = {
  active?: boolean;
} & Omit<ButtonProps, "color">;

export const SecondaryButton = ({ active = false, ...otherProps }: SecondaryButtonProps) => {
  return <Button {...otherProps} color={active ? "secondary_active" : "secondary"} />;
};
